/*
 * Stands in the diagnosis dropdown for "this order answers a refill request".
 *
 * It used to be diagnosis id 1, faked into the list in the browser. Any real
 * diagnosis that happened to get id 1 would then have shown a "Reject Order"
 * button and been saved as a refill. A string cannot be a diagnosis id, and the
 * server now decides "is this a refill" from the refill id, not from this.
 */
export const REFILL_OPTION = "refill";
